// extracted by mini-css-extract-plugin
export default {"appContainerStyle":"styles_appContainerStyle__vrg9Y","appImgWrapperStyle":"styles_appImgWrapperStyle__eeuPg","imgStyle":"styles_imgStyle__rj4Rr"};